module.exports = __webpack_public_path__ + "static/media/United States of America.ede8e635.png";